export const BACK_ACTION = {
  CLOSE: "close",
  PREVIOUS_STEP: "previous-step",
} as const;

export type SyncWizardBackAction = (typeof BACK_ACTION)[keyof typeof BACK_ACTION];

export const getSyncWizardBackAction = (step: number): SyncWizardBackAction =>
  step > 1 ? BACK_ACTION.PREVIOUS_STEP : BACK_ACTION.CLOSE;
